.loading-image {
  display: inline-block;
  z-index: 0;
  &.loading-error {
  }
  .dim {
    opacity: 0.5 !important;
  }
  .integration-logo-image {
    width: 20px;
    height: 20px;
  }
}
